export default __webpack_public_path__ + "static/media/DSHeader.7a15eb86.jpg";